import {tablesTableData} from "../../../variables/general";
import {Flex} from "@chakra-ui/react";
import School from "./School";

function SchoolSetup() {
    return (
        <Flex direction='column' pt={{base: "120px", md: "75px"}}>
            <School
                title={"School Table"}
                captions={["SN","School Detail","Contact Info","Bell Info","Status", ""]}
                data={tablesTableData}
            />
        </Flex>
    );
}

export default SchoolSetup;